import { getToken } from "../../setup/api";

export default {
  user: null,
  fullScreenLoading: false,
  logged: !!getToken(),
  coproducers: [],
  coproducerOrders: [],
  count: 0,
  myCoproducers: [],
  pagination: {},
  accountInfo: {},
  achievements: [],
  bankAccounts: [
    {
      id: 1,
      name: "Jose Silva Medeiros",
      bank: "001 - Banco do Brasil S.A.",
      agency: "0001",
      account: "1234567-8",
      document: "12312312312",
      type: "Conta Corrente",
      typePerson: "Pessoa Física",
      status: "ATIVA"
    },
    {
      id: 2,
      name: "Jose Silva Medeiros",
      bank: "077 - Banco Inter S.A.",
      agency: "0002",
      account: "8765432-1",
      document: "12312312312",
      type: "Conta Poupança",
      typePerson: "Pessoa Física",
      status: "ATIVA"
    }
  ],
  preferences: {
    product_list: localStorage.getItem("productsDisplay") || "gallery"
  },
  survey: []
};
